export default "__VITE_ASSET__vBrr7d8B__"